import { useCallback, useEffect, useRef } from 'react';

// Makes the latest request win. Check `signal.aborted` after each `await`, not the error's type:
// `customAxios`'s `onError` rewrites every error, aborts included.
export function useLatestRequestSignal() {
	const controllerRef = useRef<AbortController | null>(null);

	const abort = useCallback(() => {
		controllerRef.current?.abort();
		controllerRef.current = null;
	}, []);

	const nextSignal = useCallback(() => {
		controllerRef.current?.abort();
		controllerRef.current = new AbortController();

		return controllerRef.current.signal;
	}, []);

	useEffect(() => abort, [abort]);

	return { nextSignal, abort };
}
